import {
  DeleteStripeProductLinkRequestBodyType,
  DeleteStripeProductLinkResponseBodyType,
  PostStripeProductLinkRequestBodyType,
} from "@intelligems/ig-types/functions/stripe-product-links";
import { adminKeys } from "@src/api/queryKeys";
import { ApiRequest } from "@src/api/types/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

const deleteStripeProductLink = async (
  payload: ApiRequest<DeleteStripeProductLinkRequestBodyType>
) => {
  const resp = await api.delete<
    DeleteStripeProductLinkResponseBodyType,
    PostStripeProductLinkRequestBodyType
  >(`/v2/admin/stripe-product-links/${payload.body.stripeProductLinkId}`, {
    data: payload.body,
  });
  return resp.data;
};

export const useDeleteStripeProductLink = (id: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation<
    DeleteStripeProductLinkResponseBodyType,
    Error,
    ApiRequest<DeleteStripeProductLinkRequestBodyType>
  >({
    mutationFn: async (
      data: ApiRequest<DeleteStripeProductLinkRequestBodyType>
    ) => deleteStripeProductLink(data),
    onSuccess: async () => {
      if (id) {
        await queryClient.invalidateQueries({ queryKey: adminKeys.agency(id) });
      }
    },
  });
};
